import { render, staticRenderFns } from "./UserText.vue?vue&type=template&id=e4e94b14&scoped=true&"
import script from "./UserText.vue?vue&type=script&lang=js&"
export * from "./UserText.vue?vue&type=script&lang=js&"
import style0 from "./UserText.vue?vue&type=style&index=0&id=e4e94b14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e94b14",
  null
  
)

export default component.exports